import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FolderApiService } from '../../services/folder-api.service';
import { PlanogramApiService } from '../../services/planogram-api.service';
import { PlanogramService } from '../../services/planogram.service';
import { ToastService } from '../../services/toasts.service';
import { FolderPlanogram, FolderPlanogramState } from '../../models/folder';
import { PlanogramStatusType } from '../../models/planogram-status';
import { EventsService } from '../../services/events.service';
import * as requests from '../../requests';
import { EventType } from '../../models/events';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-external-home',
    templateUrl: './external-home.component.html',
    styleUrl: './external-home.component.scss',
    encapsulation: ViewEncapsulation.None,
    imports: [DatePipe]
})
export class ExternalHomeComponent implements OnInit {
  isLoading: boolean = true;
  planograms: FolderPlanogram[] = [];

  constructor(
    private router: Router,
    private toastService: ToastService,
    private folderApiService: FolderApiService,
    private planogramService: PlanogramService,
    private planogramApiService: PlanogramApiService,
    private eventService: EventsService
  ) {}

  ngOnInit(): void {
    this.loadSharedPlanograms();
  }

  loadSharedPlanograms(reset: boolean = true): void {
    this.isLoading = true;
    this.folderApiService.getUserSharedPlanograms().subscribe({
      next: (planograms) => {
        this.planograms = planograms;
        this.isLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.isLoading = false;
      },
    });
  }

  getLatestState(planogram: FolderPlanogram): FolderPlanogramState | null {
    if (!planogram.states?.length) return null;
    return planogram.states.reduce((latest, current) => 
      new Date(current.dateCreated) > new Date(latest.dateCreated) ? current : latest
    );
  }

  async openPlanogram(planogram: FolderPlanogram): Promise<void> {
    try {
      let stateIdToLoad: string | null = null;
      if (planogram.states && planogram.states.length > 0) {
        const sortedStates = [...planogram.states].sort((a, b) => new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime());
        stateIdToLoad = sortedStates[0].guid;
      }

      await this.eventService.createEvent({
        planogramId: planogram.guid,
        eventType: EventType.PLANOGRAM_VIEWED,
        description: 'User viewed the planogram',
        metadata: stateIdToLoad
      });

      const route = stateIdToLoad ? `/planogram/${planogram.guid}/${stateIdToLoad}` : `/planogram/${planogram.guid}`;
      this.router.navigate([route]);
    } catch (e) {
      this.toastService.show(
        'Planogram cannot be loaded right now.',
        { classname: 'bg-warning text-dark p-3 fs-5', delay: 3000 }
      );
    }
  }
}
